import { create } from 'zustand';

import type { GlobalErrorDialogProps } from './types';

/**
 * GlobalErrorDialogの状態管理
 */
type GlobalErrorDialogState = {
  /**
   * @note
   * `props`が`null`かどうかでダイアログの開閉を制御すると、ダイアログが閉じる際のアニメーション時に
   * タイトルやメッセージが消えてしまうため、isOpenで別途開閉状態を管理する
   */
  isOpen: boolean;
  props: GlobalErrorDialogProps | null;
  open: (props: GlobalErrorDialogProps) => void;
  close: () => void;
};

export const useGlobalErrorDialog = create<GlobalErrorDialogState>((set) => ({
  isOpen: false,
  props: null,
  open: (props) => set({ isOpen: true, props }),
  close: () => set((prev) => ({ ...prev, isOpen: false })),
}));
